<template>
    <div class="page">
        <navigation-bar Back Bell/>
        <div class="main">
            <div class="top_card_img">
                <img src="@/assets/images/card.jpg">
            </div> <!--end of top_card_img-->
            <div class="top-text">
                <img src="@/assets/images/pig.svg">
                <div class="con">
                    <div>本月：已為您省下 <span><b class="red">688</b>元</span></div>
                    <div>累積：已為您省下 <span><b class="red">3688</b>元</span></div>
                </div>
            </div>
            <div class="shadow-line mr-0 ml-0"></div>
            <category-content class="coupon-body">
                <!--<el-row type="flex" justify="center" class="button-line">
                    <el-button type="primary" class="donate-btn" round>
                        <img src="@/assets/images/icon-card-trans.svg">轉贈
                    </el-button>
                </el-row>-->
                <el-row type="flex" justify="space-between">
                    <el-col :span="24" class="name overflow-omitted">
                        台灣享樂遊
                    </el-col>
                </el-row>
                <el-row type="flex" class="info-line">
                    <el-col :span="6" class="text-left">
                        適用分店
                    </el-col>
                    <el-col :span="16" class="overflow-omitted">
                        <span class="branch-name">全省特約商店</span>
                    </el-col>
                    <!--<el-col :span="2" v-show="storeNameList.length > 0">
                        <el-button circle @click="$router.push({name: 'Branches', params: {storeNameList}})">
                            <i class="el-icon-arrow-right"></i>
                        </el-button>
                    </el-col>-->
                </el-row>
                <el-row type="flex" class="info-line">
                    <el-col :span="6" class="text-left">
                        活動檔期
                    </el-col>
                    <el-col :span="16" class="overflow-omitted">
                        2021-04-01~2022-04-30 止
                    </el-col>
                    <el-col :span="2"></el-col>
                </el-row>
            </category-content>
            <div data-v-58780be4="" class="discount"> 折扣類型 <span data-v-58780be4="" class="amount">85折</span></div>
            <el-row class="description">
                <p class="title">注意事項</p>
                <ol>
                    <li></li>
                </ol>
            </el-row>
        </div>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>

        <comm-dialog />

    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import CommDialog from '@/components/CommDialog.vue';

    export default {
        name: "CardPage",
        components: {
            CategoryContent,
            CommDialog
        },
        data() {
            return {
                storeNameList: [],
            }
        },
        created() {

        },

        beforeUpdate() {

        },
        beforeDestroy() {

        },
        methods: {

        }
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
